import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  footer: {
    backgroundColor: '#f8f9fa',
    borderTopWidth: 1,
    borderTopColor: '#e9ecef',
    paddingVertical: 20,
    paddingHorizontal: 20,
    marginTop: 'auto',
    width: '100%'
  },
  footerContent: {
    maxWidth: 1200,
    marginHorizontal: 'auto',
    alignItems: 'center',
    justifyContent: 'center'
  },
  poweredByContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10
  },
  poweredBy: {
    color: '#6c757d',
    fontSize: 14,
    fontWeight: '500',
    marginRight: 8
  },
  copyright: {
    color: '#6c757d',
    fontSize: 12,
    textAlign: 'center'
  }
});

export default styles;